var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_15_167"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_15_167)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.6382060546875,2.26793826171875L8.9093360546875,10.99741826171875L17.6362060546875,19.72431826171875L15.3670060546875,21.99421826171875L6.6394760546875,13.26661826171875L6.6368860546874995,13.26991826171875L4.3670279046875,11.00001826171875L4.3702622346875,10.99741826171875L4.3612060546875,10.98841826171875L6.6304260546875,8.71850826171875L6.6394760546875,8.72755826171875L15.3690060546875,-0.00128173828125L17.6382060546875,2.26793826171875Z",
    fill: "#C1C1C1",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShang);
export default __webpack_public_path__ + "static/media/shang.b680dbc67abde01f6c4f51e35bb56606.svg";
export { ForwardRef as ReactComponent };